import React, { useState, useEffect, forwardRef, useMemo } from 'react';
import Tabler from './Tabler.jsx'

const TableOverview = forwardRef((props,ref) => {
	const columns = useMemo(() => [
		{"dataIndex": ["name"], "title": "Jméno", "width": 250, "options": {"type": "text", "sortable": true, "searchable": true}},
		//{"dataIndex": ["done"], "title": "Rozpracováno", "width": 150, "options": {"type": "number", "sortable": true, "searchable": true}},
		{"dataIndex": ["cnt"], "title": "Počet", "width": 150, "options": {"type": "number", "sortable": true, "searchable": true}},
		{dataIndex: "last",      title: ""},
	], []);

	return <Tabler
		{...props} 
		columns={columns}
		sortData={[{'field': "name", "direction": "asc"}]}
		ref={ref}
	/>;
});

export default TableOverview;
